<template>
  <div>
    <b-table responsive v-handy-scroll v-bind:items="rows" v-bind:fields="fields" no-local-sorting
             v-bind:sort-by.sync="sort.field" v-bind:sort-desc.sync="sortIsDesc"
             striped hover @row-clicked="onRowClicked" v-bind:busy="loading"
             @sort-changed="onSortChanged" v-resizable
             style="white-space: nowrap; padding-bottom: 30px"
    >
      <template #cell(type)="data">
        <b-badge :variant="getTypeBadge(data.value)">
          {{ $t('ticketTypes.' + data.value) }}
        </b-badge>
      </template>

      <template #cell(status)="data">
        <b-badge :variant="getStatusBadge(data.value)">
          {{ $t('ticketStatuses.' + data.value) }}
        </b-badge>
      </template>

      <template #cell(priority)="data">
        <b-badge :variant="getPriorityBadge(data.value)">
          {{ $t('ticketPriorities.' + data.value) }}
        </b-badge>
      </template>

      <template #cell(creationTime)="data">
        {{ data.value | momentDateTime }}
      </template>

      <template #cell(lastUpdate)="data">
        {{ data.value | momentDateTime }}
      </template>
      <template #cell(lastCommentedBy)="data">
        {{ data.value ? getUserFullName(data.value) : "" }}
      </template>

    </b-table>

    <div class="mt-2 text-center">
      <div class="d-inline-block">
        <b-pagination
            v-model="pagination.page"
            v-bind:total-rows="pagination.total"
            v-bind:per-page="pagination.size"
            @page-click="onPageClick"
            align="center"
        ></b-pagination>
      </div>
      <div class="d-inline-block">
        <b-select class="d-inline-block" style="width: 70px" size="sm" v-model="pagination.size" @change="refresh">
          <b-select-option v-bind:value="25">25</b-select-option>
          <b-select-option v-bind:value="50">50</b-select-option>
          <b-select-option v-bind:value="100">100</b-select-option>
        </b-select>
        /{{ pagination.total }} {{ $t('menu.tickets') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import mixinTable from '@/components/mixin/mixinTable'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import mixinBase from '@/components/mixin/mixinBase'

export default {
  name: 'TicketsTable',
  mixins: [mixinBase, mixinTable, mixinNotifications],
  data: () => ({
    rows: [],
  }),
  props: {
    filters: {
      default: () => ({})
    },
    lazy: {
      default: () => false
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.pagination.page = 1
        this.refresh()
      }
    }
  },
  created() {
    this.setPagination(1, 0, 25)
    if (!this.lazy) {
      this.refresh()
    }
  },
  computed: {
    ...mapGetters("data", ["getUserFullName"]),

    fields() {
      return [
        { key: 'creationTime', label: this.$t('columns.creationTime'), sortable: true },
        { key: 'lastUpdate', label: this.$t('columns.lastUpdate'), sortable: true },
        { key: 'id', label: 'ID', sortable: true },
        { key: 'title', label: this.$t('columns.title'), sortable: true },
        { key: 'type', label: this.$t('columns.type'), sortable: true },
        { key: 'status', label: this.$t('columns.status'), sortable: true },
        { key: 'priority', label: this.$t('columns.priority'), sortable: true },
        { key: 'lastCommentedBy', label: this.$t('columns.lastCommentedBy'), sortable: true },
        { key: 'assignedTo', label: this.$t('columns.assignedTo'), sortable: true },
        { key: 'createdByName', label: this.$t('columns.createdBy'), sortable: true },
      ]
    },
  },
  methods: {
    ...mapActions('ticket', ['getAllTickets']),
    getTypeBadge(type) {
      const map = {
        NEW_FEATURE: 'primary',
        BUG: 'danger',
        CLAIM: 'warning',
        TASK: 'info',
      }
      return map[type] || 'secondary'
    },
    getStatusBadge(status) {
      const map = {
        REQUEST: 'info',
        IN_PROGRESS: 'warning',
        WAITING_FOR_USER_RESPONSE: 'secondary',
        DONE: 'success',
        CANCELLED: 'danger',
        DUPLICATED: 'dark',
      }
      return map[status] || 'light'
    },
    getPriorityBadge(priority) {
      const map = {
        LOW: 'light',
        MEDIUM: 'info',
        HIGH: 'warning',
        CRITICAL: 'danger',
      }
      return map[priority] || 'light'
    },
    async refresh() {
      let $this = this
      let loadingToken = this.setLoading()
      let sort = { ...this.sort }
      if (sort.field == null) {
        sort.field = 'lastUpdate'
      }
      const result = await this.getAllTickets({
        pagination: this.pagination,
        sort,
        filter: this.filters,
      }).catch(err => {
        $this.showErrorNotification($this.$t('globalMessages.fetchDataError', { system: $this.$t('menu.tickets') }), $this.getErrorDescription(err))
        $this.setLoaded(loadingToken)
      })
      if (result) {
        this.rows = result.data
        this.setMetaDataFromResult(result)
      }
      this.setLoaded(loadingToken)
    }
  }
}
</script>

<style scoped>
</style>
